//*****************************************************************************************************************
//*****************************************************************************************************************
//*************************************(IF YOU HAVE REACHED HERE)**************************************************
//********************************(PLEASE UNDERSTAND THIS PROJECT IS)**********************************************
//****************************************(MADE AND MANAGED BY)****************************************************
//******************************************(KUSHAL VERMA)*********************************************************
//******************************(DON'T TRY TO COPY OR STEAL THIS PROJECT)******************************************
//***********(DO APPRECIATE THE TIME AND EFFORTS THAT I HAVE SPENT IN MAKING THIS PROJECT ALL BY MYSELF)***********
//***************************************(GITHUB: vkushal28)*******************************************************
//****************************(FEEL FREE TO REACH ME OUT FOR ANY QUERIES)******************************************
//**************************(for personal mails : vermakushal.28@gmail.com)****************************************
//*************************(for work related mails : kush.expclick@gmail.com)**************************************
//*****************************************************************************************************************
//*****************************************************************************************************************

//*******************Demo pattern of objects****************
// {
//   img:
//     "https://drive.google.com/uc?export=view&id=",
//   frame: "",
//   location: ""
// },

export const wallpapersURLs = [
  {
    img:
      "https://drive.google.com/uc?export=view&id=1pMftlWhpkzVwUCfPLqJ_wtp3BgnPNeqR",
    frame: "Early morning golden hour",
    location: "Meerut, Uttar Pradesh, India",
  },{
    img:
      "https://drive.google.com/uc?export=view&id=1vkkoUtSj3AQdEuNvWmlqoxN23uUzX5pJ",
    frame: "Splash of water",
    location: "Meerut, Uttar Pradesh, India",
  },{
    img:
      "https://drive.google.com/uc?export=view&id=1F1TTb9DXDkEjZ4FNXCwiQqwQTpcDREnP",
    frame: "A beautiful nest in front of my home",
    location: "Meerut, Uttar Pradesh, India",
  },{
    img:
      "https://drive.google.com/uc?export=view&id=1W8I355lGRzuG3flpCmo2XIPIgi6hH8Ww",
    frame: "Still bee careful",
    location: "Meerut, Uttar Pradesh, India",
  },{
    img:
      "https://drive.google.com/uc?export=view&id=1uBi8_zynIU2UcXHh8VqmNLJOCv_c7dGB",
    frame: "That single got mingle",
    location: "Meerut, Uttar Pradesh, India",
  },{
    img:
      "https://drive.google.com/uc?export=view&id=1rjIVTzh4yoCzAOeze3ZJ7hBRy94UV6wm",
    frame: "Bengal currant (Karaunde in hindi)",
    location: "Meerut, Uttar Pradesh, India",
  },{
    img:
      "https://drive.google.com/uc?export=view&id=1lWG00O3HBozsJgGAFlPkw9xSTV-dyW9Z",
    frame: "",
    location: "Meerut, Uttar Pradesh, India",
  },{
    img:
      "https://drive.google.com/uc?export=view&id=1hf6mOQaZrJofrfLkJ5ekQjsj4afVS8Ni",
    frame: "Guava tree",
    location: "Meerut, Uttar Pradesh, India",
  },{
    img:
      "https://drive.google.com/uc?export=view&id=1fU7RuGcRcy1UZI5VYd8TSS4J7I8ubElG",
    frame: "Clouds like volcano",
    location: "Meerut, Uttar Pradesh, India",
  },{
    img:
      "https://drive.google.com/uc?export=view&id=1beF_4gKCTxs0qMiUwPHcnMJaCnElAoBg",
    frame: "",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1Z5kLtDm04rpPYaeZ4ov_txnfUOORHb_Z",
    frame: "",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1GRxq-X2V9f7kI1ScXHhSJzMnAESeCebW",
    frame: "Bee careful",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1cmcqWjOOWbFrxTLz3MBwD3aE296dztpb",
    frame: "",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1IyCYiRbY_4VF5VaDPCbj0MkF4N4YSvt5",
    frame: "They also feel cold!!",
    location: "Meerut, Uttar Pradesh, India",
  },{
    img:
      "https://drive.google.com/uc?export=view&id=1oSD557ijtx6L1Q7wg1i7hd1w3ZuMgOhd",
    frame: "Symmetry OP",
    location: "Meerut, Uttar Pradesh, India",
  },{
    img:
      "https://drive.google.com/uc?export=view&id=1oAmb6_jsEBRVAoV188VRHMq5mcxZfsNE",
    frame: "Bird inside home",
    location: "Meerut, Uttar Pradesh, India",
  },{
    img:
      "https://drive.google.com/uc?export=view&id=1YbmrcPgfd28p9ZZT0HhxIJJqQ0mgGIJd",
    frame: "Single AF",
    location: "Meerut, Uttar Pradesh, India",
  },{
    img:
      "https://drive.google.com/uc?export=view&id=1RdF_Z_PhMYwIOSBpXlDnTwjOgnEONzws",
    frame: "Ant",
    location: "Meerut, Uttar Pradesh, India",
  },{
    img:
      "https://drive.google.com/uc?export=view&id=1NQKhi_YFKhoxbHbFAvX2eWyRUVcAZNoE",
    frame: "Probably waiting for other friends",
    location: "Meerut, Uttar Pradesh, India",
  },{
    img:
      "https://drive.google.com/uc?export=view&id=1MtNVPT0uhwiKctjyh1l3PFHFaTPnPMpe",
    frame: "Social distancing",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1sf-OJixigQq9_9xBLmjO103_mI9BuHad",
    frame: "Taro root/Eddoe",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1dBAgM8vb10e6Y7EhRz35czZ8-1WnnuxQ",
    frame:
      "An amazing view of the sky captured on mirror by One Plus nord + google cam",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1x4Z7XP953x3vFNgj97a8cXT44yLEp0_b",
    frame: "Guava leaves during rain",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=12IJ5l9Rhpz7Cl9GXKmPYymybUaoTb199",
    frame: "Backlit guava tree leaves, captured with one plus nord",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1c8rzOs_HOFRfoB-J-wbAX9rgrrK5AHxF",
    frame: "HP probook",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1904JZIny2MkSDasncEF6Jv4hQQAM79q_",
    frame: "Tried to get the borders in focus",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1AOB7YQrY-TA__RRFlh2T0QPhSzKvVIY9",
    frame: "Shooting star captured with One plus nord + google cam",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1FRDyxu-A-Z6BOlsPj4jweUvX14Mh6xDb",
    frame:
      "Stars captured with One plus nord + google cam in astrophotography mode",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1h4-ziJeX_SqqsMPyLOqTxglYvQjDk_pE",
    frame: "Lily flower",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=158FjCV5WhQMuJuJpOdeUO3BuPfrBt94v",
    frame: "Golden fish",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1gtB943-RTxK8FdvYyNA-qxuXldo_rhkS",
    frame: "An old vintage car",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1XHU3hOHOzyHSj3vW42gqtsNIH8mORWIS",
    frame: "Tree patterns",
    location: "Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1VZ0M2HuETFVz78ayOX-us5Qh0tXjQqTU",
    frame: "Old times gates made of hand crafted patterns",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1GjUtfIfohb5GAs4lrYL68Xd8SfOtFbfP",
    frame: "A part of a tree whose leaves grows like this",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1hlrgVSfxfAShUr4TqkrBZ5Rldtpo_eVJ",
    frame: "A manipulated picture of tree that looks wonderful as a wallpaper",
    location: "Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=11B9G0AN9l4ACZmlcnHjpRd127QZpfY4I",
    frame: "Random street of Mysore",
    location: "Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1iaqbnUJaFALieVpAN5DyEj-wdL9mfR40",
    frame: "Soap bubble",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1o8tUkuPWizX_2Cx5biPnpxu_uG3jk5Bg",
    frame: "Bandra",
    location: "Mumbai, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1dLZbtjRr7eRVVXVqSx_VonUGBcz0M77v",
    frame: "Part of a leaf",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1jTbwl8WwDdodhlLUPV5gjOMqw4_JEnHL",
    frame: "Bandra worli sea link",
    location: "Mumbai, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1e83UdPiWLkAMMAeR4P07Dg5vdO7ThtO4",
    frame: "Legs of Abbas jamali (friend)",
    location: "Pune, Maharashtra, India",
  },

  {
    img:
      "https://drive.google.com/uc?export=view&id=1A5hYyDak2pVWRrQVmRLRgRZBt6Zs8nGd",
    frame: "Legs of Abbas jamali (friend)",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1OctM8iqN3Mg03mzrjxK-Yl_iYCEGYT1y",
    frame: "Wood structure from street vegetable market",
    location: "Mahatma Phule Bai Mandai, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1zY8LYoB7afAUQVjGB4oD3PHGYCLxZRW-",
    frame: "A random tree from street",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1y6iZzvgMfUeWj7qiG8fND_YU7em6gh4y",
    frame: "Onions in wholesale",
    location: "Mahatma Phule Bai Mandai, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1bUq1gzp8Zf6BkorL0zUWFEBrNbnsA1ZU",
    frame: "A random pole from street",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1J_fEKeyc9fJICGCcnqptYrshH6F7-PLS",
    frame: "A random pole from street",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=17BMR-RIaRpfiJwhH5s2y7Chq2zXgs9AG",
    frame: "A random tree from street",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1NUdFteR1X3YJwiY0NyFgrrmjPH5paP2z",
    frame: "Pimpri market, Pune",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1LRqnkxbME4UycuX-TM9-zYsy0xaJ5QFR",
    frame: "Random house in street",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1EgWlj8LW3_BmMlTzAOgQ506SmmanhpOa",
    frame: "Beautifully carved pole near Shaniwar Wada",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1BgndxQrQKoJ8xA9zal_twBOar53fGEhZ",
    frame: "A random pole from street",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1JeYBPJcg4zJlygcBA96sZK531RbdePjn",
    frame: "Flats in Tinseltown (underground view)",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=173FvVYnJylFpGwEb8iE2sNN0pcFX3BFj",
    frame: "Alcohol samples",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1I5DM37Cpr0uanrLrnMajIikMax8Ug9yX",
    frame: "Tree patterns",
    location: "Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1x8iGT36DIpeZqz-AKzd0kG2BGMSaYJqw",
    frame: "Christmas tree leaves",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1wzbZ1Ty1KkSru5Km4RrgZNAbuW7yXpvq",
    frame: "Random tree leaves",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1wh8gNxOnWaNiZz6EnF6soaqERAprfq1g",
    frame: "Random bird on pole",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1m0qJzo5Y7gc0cNb5cI8zi0o5tW3VFTle",
    frame: "Frame in frame in Pune streets",
    location: "Alka chowk, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1S8XG7-ueotD09KPZgA2lEqS8Ggpbaa2a",
    frame: "Random tree leaves",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1M8LnfmPcn63P__FPIX3pVNFk9ZFRbtIc",
    frame: "Night sky in Tinseltown",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1KQYkj0y3DNZ2ZNrurbd4F2Pq-GqNxIXw",
    frame: "After sunset scenes",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=18VjmkwN54kMjhNbvcUTzAIVfjgyjFnhE",
    frame: "Random tree leaves growing up",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=10b3Qlt_99QgYZOyL9lE3MTcLj8BnZTIA",
    frame: "Random bird on wire",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1sfZ8-uk63RlhqaYudUyTCBg1zNnIAIWd",
    frame: "Legs of Abbas jamali with a water splash during sunset",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1iOZkgGt4KovLgw6V5-Uaet-K09Jgh5Sg",
    frame: "Legs of Abbas jamali with a water splash during sunset",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1ayKhWWpPZInPRgmFDoMjRSEUIyNoUN2p",
    frame: "Legs of Abbas jamali with a water splash during sunset",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1Qe3ads6ImwAERYtRvggOU9vDvuIi3KQW",
    frame: "Legs of Abbas jamali with a water splash during sunset",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=15IS20LGrH9yQkDgzg0xda4TwkZMHIR6v",
    frame: "Legs of Abbas jamali with a water splash during sunset",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1O-u30XWIxzbeu8TTzJdMkELZGEZoG-Bu",
    frame: "Canon EF-S zoom lens (55-250mm)",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1yMw-QXHVeBlB703zg6-6V8NYs-p9VMnP",
    frame: "Plants grown in waste plastic bottles",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1AWOcbndso2oc1vUU19v5hFn2KGV1aLYI",
    frame: "Group of birds sitting on a mobile tower",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=13bABlbIHKL7nda656hlekNP_zslzMPxg",
    frame: "Group of birds sitting on a mobile tower",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1d3phTfeU453a_F6jAyrhZdsNezhQfh6x",
    frame: "Soap bubble",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1WQX_2uOAGzjBn4MxCTLXk2P4Saa7AJx0",
    frame: "Soap bubble",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1c0DDEFi79hjCKhgb8pYjU5HgE5y-SsQw",
    frame: "A random flower in my house",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1ToOiQUyEZrl5w5ZMQOkdNGneXSmfpEul",
    frame: "Spring flowers",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1K8De6_-QSqbklRX5lh6lK5raFYsFnKg6",
    frame: "Framed this bird between leaves",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=14ABADaYrLyuuY5eNTtVUWZ-K80m2LAwi",
    frame: "Amazing silhouette of birds",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1PBTSM0UGcs9i-q1qDjoMIw4fK7IyP1qX",
    frame: "Bird sitting on tree branch",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1mYnBTUYB3gjZhyX6lF82KpUFYDgO2Ile",
    frame: "Bird sitting on tree branch",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=159_82SBjD6WPxMDToAVnJobYuFKNZwr1",
    frame: "Low key shot of a rose flower",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1XcVNKRVvv2LYF5mSGYE9aSRCGNU88Zme",
    frame: "Ray of light dividing the frame",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1TJd_3XMdTlsaUhMzSYCpC-HjiUyCloMB",
    frame: "Sunset view",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1KzOdl_KAtgT_GrPdCTQr0a5u3KEDo8f6",
    frame: "Sunset view with bird in frame",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1GRLXsvaa8r8oLiyFD65QP_yxJfAKGt3P",
    frame: "Flower",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=17yc6oLhvXy2km4mdDWO_CQ3TxTcs8j-0",
    frame: "That bird going away from frame",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=12_OIKy1sxF30RWP8UUTNz70rL-TR1_gl",
    frame: "Leading lines",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1h8r6QwvI-0BJJXnSTKolpXcRCFBm8fpG",
    frame: "Aperture blades and reflection",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1ORZrQILxaqQB-hAt0eixgSAmQxAGRh5B",
    frame: "Moon",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=19Ec_UzVFYccVlHh6XXGubOJPsgV69GRe",
    frame: "Moon",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1CeOC-npapyLntZ25K-pJxlqKtD7OaoMb",
    frame: "Moon",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1LmLv25uMeLaJZg6PuToEbex96uS7e3He",
    frame: "Moon",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=16azBthBrT_G_X6VkYxRp7E3bhUmdtJe-",
    frame: "Moon with a bird in focus",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1qf7fEQuFSMPwwLGjHrVa4jKy4RaV-G35",
    frame: "Aperture blades of a canon 50mm lens",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1lyOrM7we3Bvo-1FE8fT2LkS43PThuzsa",
    frame: "Rose flower",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1cKX4KgVcdYbTmieD-i60G8VKni6LBYfl",
    frame: "Flying birds",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1XARQrhYJCNsBICJQtocAXipputW8dPdo",
    frame: "A bird sitting on an electric pole",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1RFoa_k6MAMo6HD4ZL0hfphi2cHPAQAn6",
    frame: "Crow sitting on Bandra fort",
    location: "Mumbai, Maharashra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1QU0205Gj2IP8YxDf9HLPSPePaLYbBMUr",
    frame: "Rose flower",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1P6_jYWbidkacCrvnxWFDdHzgAGtjiL3E",
    frame: "Aperture blades and reflection",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1Jw9WltQZsm9PD73M_W-c6q0Hiro2wcl2",
    frame: "Bird within a guava tree",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1eJlfsbkPlE4Z0wK9oFhb618AqtOQy87p",
    frame: "Sunset sky",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1Fl9VzA2GepyafDPTruKhqOu_duQE6dQa",
    frame: "Random plant",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1spDS2WfyPx-7IHFsgkffq3xpAnBw60AE",
    frame: "Soap bubble",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1sn6gUjH1hOWnSAqGpFjKi8DuZZbsAwx3",
    frame: "Friends",
    location: "Lavasa, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1rReZKjumjb-oIajroV17ePWy4QKdyO0_",
    frame: "Lily flower",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1p4_6HCgDLKs5CSCByM_J5pB2QzVqoR1w",
    frame: "House fly",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1gctYHvrmE4qoXJoDAg0NZ6dJHY_1U6FH",
    frame: "Reflection on water",
    location: "Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1_VjWFD_9isJ3L5psslTB_gEuJL53YFag",
    frame: "Soap bubble",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1LsNcbVRCZIPx7ODTHdDom4e3aWp2u2MA",
    frame: "Ceiling made with threads and ropes",
    location: "Planet 9 bistro, Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1AIdN1NVL2U8LaBxP3i0Y2-DwDXEYVVdR",
    frame: "Roads inside Infosys Mysore campus",
    location: "Mysore, Karnataka, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=18y5zbsETGzJpBcU6SxQpyd1Ijdt9TNuZ",
    frame: "Frame in frame",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=13eCJ8DArchJxNfnbAQ7jDimJXdt4Doji",
    frame: "Frame division",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1m1sLdd2xSh6XDzOnQF8bWwtR5DC0XWCi",
    frame: "A toy car product photography",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1ZKlgh0oAs5HrY2d1d5_ZT5ZxKvQIePHd",
    frame: "A toy car product photography",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1J9a6kTNKE9qrKS8WQyc7q_m9grN_5HpC",
    frame: "A toy car product photography",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=117V3_skuTc1EfUNdIZ81ONjFVpYXfA70",
    frame: "A toy car product photography",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1QEWl2_qDYV84A8pfcZL12otiPzj7AWEJ",
    frame: "Macro shot of yeast",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1PrrYC20UGCsLPt1eSvw75rpGGJjyfM9y",
    frame: "Macro shot of yeast",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1HVv8sXAMUK5wg1sKcaY04bZDQCDBXn59",
    frame: "Macro shot of yeast",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=117V3_skuTc1EfUNdIZ81ONjFVpYXfA70",
    frame: "A toy car product photography",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1-Ywiq8NE9GGVFQcu7O6KdXpHIZLIQmki",
    frame: "A toy car product photography",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1C29Eu4c3zuCYoOUURif1bjMRa26_a7Bx",
    frame: "Pigeon",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=10Ap3GERik3E69XflLSPMyC9outww6WJe",
    frame: "Pigeon",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1rElm4Ltarw1W_oL12seBDf2eI1cYqJQb",
    frame: "Clouds",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1c7gOEp0Mrp6cu94wxFyJJ3GsM-kA9Lp6",
    frame: "Crow flying",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1WK94bbKZe1ca-xaM3t2e1xu2yXbiZbEg",
    frame: "Lightpole",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1Gq0eGeghqQEkjU8SmoerlCiAVyDnkzSA",
    frame: "Multiple things in a frame",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=17mauHStNS63CtG2Pa5bM1hKTIHPSV3BZ",
    frame: "Guava leaves",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=10DHerG3RoYXi5lgR4IF_TZOm8DozE_FV",
    frame: "Crow flying",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1yxJmN7kFqW-rfpjDT7tqccTD-KLAaL_u",
    frame: "Shutter speed in sync with blades speed though appear to be frozen",
    location: "Mumbai, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1kMXh-h-9NO1D5gokhCsBomz1xyJ3Paxd",
    frame: "Oil in water",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1iJ6lEYyEjZpTiZsRk0rfoK1VnJ8WAgju",
    frame: "Canon EF-S zoom lens 55-250mm",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1Ssh5ktgpI_l8XN766_UckkjQMlPMC4AL",
    frame: "Oil bubbles in water",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1JR-WJM76-fTsUWc_ChPfsM_032OSgyGB",
    frame: "Oil bubbles in water",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1LEMmafkJiiamoM64WmhDfNb8to6prGdy",
    frame: "Some random plant",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1EMclZZIUSqvDAusmrnowp2_XSkJv7GUZ",
    frame: "Sunset at Bandra fort",
    location: "Mumbai, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1tW5dCXGWD-5XFc5pHMFlOH8K6ySkIK0l",
    frame: "Canon EF-S 18-55mm kit lens and reflection",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1bfyE-Fscn4tw4v7qrgQGQorE-YRAE_7T",
    frame: "Oil bubbles in water with some random image from below",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1Ghlm4r_a_x93vHv_u_yuidIMZhq9-fGQ",
    frame: "Oil bubbles in water with some random image from below",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1AS9oZifEyR508iWwsbgp1qZbXCy6mvwA",
    frame: "Oil bubbles in water with some random image from below",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=19H6YKNgfCWiAf_9iiHQiTHCDAfrcC8Dq",
    frame: "Oil bubbles in water with some random image from below",
    location: "Meerut, Uttar Pradesh, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=11sqFjUpuwZ5J_YyNgcbudf2OILLoyWKF",
    frame: "Frozen motion of a flying crow",
    location: "Pune, Maharashtra, India",
  },
  {
    img:
      "https://drive.google.com/uc?export=view&id=1GHgrzO1Qfn1diBbKPtwpSRD--DoaTw-N",
    frame: "Rose flower",
    location: "Meerut, Uttar Pradesh, India",
  },
];
